import {ShowOnlySelectedCheckbox as Checkbox} from '../../show-only-selected-checkbox';
import {useActionPanelContext} from '../context';

export function ShowOnlySelectedCheckbox() {
	const {api} = useActionPanelContext();

	return <Checkbox api={api} />;
}
